// @flow

/**
 * Masks an address to show only the last 4 characters
 */
export const maskAddress = (address: string): string => {
  if (!address) return ''

  // If address is shorter than 4 characters, show it fully
  if (address.length <= 4) return address

  // Show last 4 characters
  return address.slice(-4)
}

/**
 * Extracts and formats the full address from the API response
 * @param {any} response - The API response object
 * @param {string} addressField - Optional specific field to extract (e.g., 'address1', 'address2')
 * @returns {string} - The formatted full address or specific field
 */
export const extractAddressFromResponse = (response: any, addressField?: string): string => {
  const data = response?.data?.data
  if (!data) return ''

  // If a specific field is requested, return only that field
  if (addressField) {
    switch (addressField) {
      case 'address1':
        return data.to_address1 || data.toAddress1 || ''
      case 'address2':
        return data.to_address2 || data.toAddress2 || ''
      case 'city':
        return data.to_city || data.toCity || ''
      case 'state':
        return data.to_state || data.toState || ''
      case 'district':
        return data.to_district || data.toDistrict || ''
      case 'postcode':
        return data.to_postcode || data.toPostcode || ''
      default:
        break
    }
  }

  // Combine all address fields into a formatted string
  const addressParts = [
    data.to_address1 || data.toAddress1,
    data.to_address2 || data.toAddress2,
    data.to_district || data.toDistrict,
    data.to_city || data.toCity,
    data.to_state || data.toState,
    data.to_postcode || data.toPostcode
  ]

  // Filter out empty values and join with comma
  return addressParts.filter(part => part && part.trim() !== '').join(', ')
}
